function chooseDocTemplateDialog () {
  return {
    restrict: 'E',
    templateUrl: '/repository/dialogs/choose-doc-template/choose-doc-template-dialog.html?$$REVISION$$'
  }
}

export { chooseDocTemplateDialog }
